import React, { useState } from "react"
// import styles from "./ProductOptionsModal.module.scss"
import styles from "../Tools/Modal.module.scss"
import SizeDropdown from "./SizeDropdown"
import Btn from "../Buttons/PrimaryButton"
import QuantityCounter from "./QuantityCounter"

const ProductOptionsModal = ({
  closeModal,
  size,
  sizes,
  quantity,
  onSubmit,
  selectedSizeUpdater,
  quantityUpdater,
}) => {
  return (
    <div className={styles.modalcontainer}>
      <div
        onClick={() => {
          closeModal()
        }}
        className={styles.background}
      />
      <div className={styles.modal}>
        <h3>Select Your Options</h3>
        <SizeDropdown
          sizes={sizes}
          onSelectSize={size => selectedSizeUpdater(size)}
        />
        <QuantityCounter
          quantity={quantity}
          onSelectQuantity={(id, quantity) => quantityUpdater(quantity)}
        />
        <Btn
          label={"Add To Cart"}
          onClick={() => onSubmit(size, quantity)}
        ></Btn>
      </div>
    </div>
  )
}

export default ProductOptionsModal
